document.addEventListener("DOMContentLoaded", function() {
    var placeholders = document.querySelectorAll('.video-yt');

    placeholders.forEach(function(placeholder) {
        var button = placeholder.querySelector('button');
        
        button.addEventListener('click', function() {
            var videoId = placeholder.getAttribute('data-video-id');
            var iframe = document.createElement('iframe');

            iframe.setAttribute('width', '560');
            iframe.setAttribute('height', '315');
            iframe.setAttribute('src', 'https://www.youtube.com/embed/' + videoId + '?autoplay=1');
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
            iframe.setAttribute('allowfullscreen', 'true');

            placeholder.innerHTML = '';
            placeholder.appendChild(iframe);
        });
    });
});
